import Swal, {SweetAlertResult} from 'sweetalert2'
import {APIResponse, SubmitAPIStatusType} from '../../types/OtherTypes'
import {AlertProps} from '../../data/AlertDefaults'
import {UPDATE_MESSAGE} from '../../../utils/contants'
import {getDate} from '../../../_metronic/helpers'
import {getGeneralConfig} from '../../../api/ConfigurationAPI'
import {
  GeneralSettingInitialInput,
  LeaveConfigInitialInput,
} from '../../data/SettingModulesDefaultData'
import {GeneralSettingInput, LeaveSettingInput} from '../../types/SettingModuleTypes'
import {getDateInYYYYMMDD} from '../attendance/ams'

export const validateGeneralSettingForm = (formField: GeneralSettingInput) => {
  let cnt = 0
  const error: any = {}
  const {formattedDate} = getDate()
  if (!formField.fiscal_year_start_date) {
    cnt = cnt + 1
    error.fiscal_year_start_date = 'Year Start Date should not be blank/invalid'
  } else if (formField.fiscal_year_start_date) {
    let newDate = formField.fiscal_year_start_date.split('-')
    if (newDate[0].length > 4) {
      cnt = cnt + 1
      error.fiscal_year_start_date = 'Year is invalid'
    }
  }

  if (!formField.fiscal_year_end_date) {
    cnt = cnt + 1
    error.fiscal_year_end_date = 'Year End Date should not be blank/invalid'
  } else if (formField.fiscal_year_end_date) {
    let newDate = formField.fiscal_year_end_date.split('-')
    if (newDate[0].length > 4) {
      cnt = cnt + 1
      error.fiscal_year_end_date = 'Year is invalid'
    } else if (formField.fiscal_year_end_date < formattedDate) {
      cnt = cnt + 1
      error.fiscal_year_end_date = 'Year End Date should not be less than current date'
    }
  }

  if (!formField.weekends) {
    cnt = cnt + 1
    error.weekends = 'Please select/enter a Weekends.'
  }

  if (!formField.week_start_day) {
    cnt = cnt + 1
    error.week_start_day = 'Please select/enter a Week Start Day.'
  }
  if (!formField.inTime.trim()) {
    cnt = cnt + 1
    error.inTime = 'Please enter/select an In Time.'
  }
  if (!formField.outTime.trim()) {
    cnt = cnt + 1
    error.outTime = 'Please enter/select an Out Time.'
  }

  const baseDate = new Date()

  const [inHours, inMinutes] = formField.inTime.split(':')
  const [outHours, outMinutes] = formField.outTime.split(':')

  const inTime = new Date(baseDate)
  inTime.setHours(parseInt(inHours, 10), parseInt(inMinutes, 10), 0, 0)

  const outTime = new Date(baseDate)
  outTime.setHours(parseInt(outHours, 10), parseInt(outMinutes, 10), 0, 0)

  // Check if out time is earlier than in time and adjust for the next day
  if (outTime.getTime() < inTime.getTime()) {
    outTime.setDate(outTime.getDate() + 1)
  }

  const timeDifferenceInMilliseconds = outTime.getTime() - inTime.getTime()
  const timeDifferenceInHours = timeDifferenceInMilliseconds / (1000 * 60 * 60)


  if (timeDifferenceInHours > 10) {
    cnt = cnt + 1
    error.outTime =
      "Please ensure that the 'Out Time' does not exceed 10 hours after the 'In Time', and Please adjust your 'In Time' and 'Out Time' accordingly."
  } else if (timeDifferenceInHours < 4) {
    cnt = cnt + 1
    error.outTime =
      "Please ensure that the 'Out Time' must be at least 4 hours after the 'In Time', and Please adjust your 'In Time' and 'Out Time' accordingly."
  }

  return {error, cnt}
}

export const validateLeaveSettingForm = (formField: LeaveSettingInput) => {
  let cnt = 0
  const error: any = {}

  // if (!formField.sandwichEnabled) {
  //   cnt = cnt + 1
  //   error.sandwichEnabled = 'Please select a Sandwich Leave Apply Or Not.'
  // }

  // if (!formField.lopCalculationType) {
  //   cnt = cnt + 1
  //   error.lopCalculationType = 'Please select/enter a LOP Calculation Cycle.'
  // }

  if (!formField.allowBackdatedLeave) {
    cnt = cnt + 1
    error.allowBackdatedLeave = 'Please select/enter a Allow Backdated Leave Or Not.'
  }

  // if (!formField.balanceCreditType) {
  //   cnt = cnt + 1
  //   error.balanceCreditType = 'Please select/enter a Balance Credit Type.'
  // }

  // if (!formField.deductOnApproval) {
  //   cnt = cnt + 1
  //   error.deductOnApproval = 'Please select/enter a Deduct On Approval Or Not.'
  // }

  if (!formField.restrictDateRange) {
    cnt = cnt + 1
    error.restrictDateRange = 'Please select/enter a Restrict Date Range Or Not.'
  }

  return {error, cnt}
}
export const getGeneralSettingData = (setSubmitAPIStatus: Function, setFormField: Function) => {
  setSubmitAPIStatus((prev: SubmitAPIStatusType) => ({...prev, loading: true}))
  getGeneralConfig().then((res: APIResponse) => {
    if (res.statusCode === 200) {
      let configurations = res?.data?.map((item) => item)[0]
      setFormField((prev: any) => ({
        ...prev,
        fiscal_year_start_date: getDateInYYYYMMDD(configurations?.financialYearStartDate ?? ''),
        fiscal_year_end_date: getDateInYYYYMMDD(configurations?.financialYearEndDate ?? ''),
        week_start_day: configurations?.weekStartDay ?? '',
        weekends: configurations?.weekendDays?.split(',') ?? '',
        inTime: configurations?.inTime ?? '',
        outTime: configurations?.outTime ?? '',
      }))
    } else {
      setFormField(GeneralSettingInitialInput)
    }
    setSubmitAPIStatus((prev: SubmitAPIStatusType) => ({...prev, loading: false}))
  })
}

// Leave Config removed – no-op retained for backward calls if any
export const getLeaveSettingData = (setSubmitAPIStatus: Function, setFormField: Function) => {
  setSubmitAPIStatus((prev: SubmitAPIStatusType) => ({...prev, loading: false}))
}
export const handleSubmit = (
  getData: Function,
  editId: any,
  formField: any,
  initialState: GeneralSettingInput | LeaveSettingInput,
  setFormField: Function,
  setInputError: Function,
  validateForm: Function,
  setSubmitAPIStatus: Function,
  updateRecord: Function,
  setShowForm: Function
) => {
  let {cnt, error} = validateForm(formField)
  setInputError(error)
  if (cnt === 0) {
    Swal.fire({...AlertProps, icon: 'warning', title: UPDATE_MESSAGE}).then(
      (result: SweetAlertResult) => {
        if (result.isConfirmed) {
          setSubmitAPIStatus((prev: SubmitAPIStatusType) => ({...prev, loading: true}))
          updateRecord(formField, editId).then((res: APIResponse) => {
            if (res.statusCode === 200) {
              setShowForm(false)
              getData(setSubmitAPIStatus, setFormField, initialState)
              setInputError({})
            }
            setSubmitAPIStatus((prev: SubmitAPIStatusType) => ({...prev, loading: false}))
          })
        }
      }
    )
  }
}
